import { render, staticRenderFns } from "./BuildingProduction.vue?vue&type=template&id=0960ed57&"
import script from "./BuildingProduction.vue?vue&type=script&lang=js&"
export * from "./BuildingProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports